import WebAppointmentListListResultModelBase from '../_generated/modelBases/web-appointment-list-list-result-model-base';

export default class WebAppointmentListListResultModel extends WebAppointmentListListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
